import axios from "axios";
import {Link} from 'react-router-dom';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function InvPayment(){
    const [invData,setinvData] = useState([]);
    const [amount, setAmount] = useState(0);
    const [balance, setBalance] = useState(0);
    const {appt_id}=useParams();

    useEffect(() => {
        try{
            axios.get(baseUrl+'inv-pay/'+appt_id)
            .then(function (response) {
                setinvData(response.data);
                setAmount(response.data[0].inv_tot);
                setBalance(0);
            });
        }catch(error){
            console.log(error);
        }
    },[]);

   const handleAmountChange = (event) => {
    let newAmount = parseInt(event.target.value, 10);
    const maxAmount = invData[0].inv_tot;
     if (newAmount > maxAmount) {
        newAmount = maxAmount;
    }
     setAmount(newAmount);
    setBalance(maxAmount - newAmount);
};

    const handlePaymentTypeChange = (event) => {
      const value = event.target.value;
      if (value === 'creditpay') {
        setAmount(0);
        setBalance(invData[0].inv_tot);
      } else {
        setAmount(invData[0].inv_tot);
        setBalance(0);
      }
    }

   const handleFormSubmit = (e) => {
      e.preventDefault();
        const dbType = document.getElementById('dbType').value;
          axios.post(`${baseUrl}get_sale_inv/`)
          .then(response => {
          const sale_inv = response.data.value;
          const _formData = new FormData();
          _formData.append('inv_paid',amount);
          _formData.append('inv_balance',balance);
          _formData.append('inv_invoice',sale_inv);
          _formData.append('inv_pmode',dbType);
          _formData.append('cashier',userName);
          _formData.append('inv_status','2');
            axios.post(baseUrl+'inv-payment/'+appt_id+'/', _formData, {
                  headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(response => {
              if(response.status==200 || response.status==201){

                Swal.fire({
                  title: 'Payment Success and Invoice is Generated',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                })
                setTimeout(() => {
                  window.location.href = ('/inv-invoice-op/'+sale_inv+'/');
                }, 3000);
              }
              })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add inv entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };


    return (
        <section className="container mt-4">
            <div className="row">
              <div className='col-md-9 col-12 mb-2'>
                <div className="row">
                    <h3 className="text-center"> OP Radiology Payment</h3>
                    <div className="table-responsive">
                      <table className="erp-table-modern">
                        <thead>
                              <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                <th>Appointment Id</th>
                                <th>Patient Id</th>
                                <th>Patient Name</th>
                                <th>Addedby</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invData.map((row,index) =>
                                  <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                    <td>{appt_id}</td>
                                    <td>{row.pat.pat_id}</td>
                                    <td>{row.pat.patient}</td>
                                    <td>{row.addedby}</td>
                                    <td>{row.inv_tot}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <form>
                        <label>Choose Payment Type</label>
                        <select name="dbType" id="dbType" onChange={handlePaymentTypeChange}>
                           <option value="cash">Cash</option>
                           <option value="card">Card</option>
                           <option value="creditpay">Credit Payment</option>
                           <option value="UPI">UPI</option>
                        </select>
                        <div className="form-group mt-3" >
                            <label style={{ fontWeight: 'bold' }}>Amount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" name="amount" id="amount" value={amount} onChange={handleAmountChange} max={amount}/>
                            </div>
                        </div>
                        <div className="form-group mt-3" >
                            <label style={{ fontWeight: 'bold' }}>Balance Amount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" name="balance" id="balance" value={balance}
                                    onChange={handleAmountChange} readOnly />
                            </div>
                        </div>
                         <button type="button" onClick={handleFormSubmit} className="btn btn-primary mt-4">
                         Submit</button>
                   </form>
              </div>
            </div>
            </div>
            </div>
        </section>

)
}

export default InvPayment;